import {createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';


export const setConnectionMethod = createAsyncThunk(
    'setting-connect-method',
    async ({ method, link }: { method: string; link: string | null}, { rejectWithValue }) => {
      const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
      try {
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}setting-connect-method`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token}`,
           },
          body: JSON.stringify({method, link }),
        });
  
        if (!response.ok) {
          throw new Error('Failed set setting-connect-method');
        }
        const data = await response.json();
        return data.data;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const getSettings = createAsyncThunk(
    'get/settings',
    async (_, { rejectWithValue }) => {
      try {
        const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );

        if (!token) {
          throw new Error('Authorization token not found');
        }
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}settings`, {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token}`, 
           },
        });
  
        if (!response.ok) {
          throw new Error('Failed get settings');
        }
        const data = await response.json();
        return data.data;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const getAccess = createAsyncThunk(
    'getAccess',
    async ({ password }: {password: string}, { rejectWithValue }) => {
      const token = Cookies.get(process.env.NEXT_PUBLIC_COOKIE_NAME ?? `cr_${process.env.NEXT_PUBLIC_COOKIE_DOMAIN_SCOPE}_token` );
      try {
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_PATH}get-access`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `${token}`,
           },
          body: JSON.stringify({password}),
        });
  
        if (!response.ok) {
          throw new Error('Failed set setting-connect-method');
        }
        const data = await response.json();
        return data.data.access;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

